const ADD_FILE = 'ADD_FILE';
const UPDATE_FILE_PROGRESS = 'UPDATE_FILE_PROGRESS';
const COMPLETE_FILE = 'COMPLETE_FILE';
const REMOVE_FILE = 'REMOVE_FILE';
const CLEAR_FILES = 'CLEAR_FILES';
const SET_OVERSIZED_FILES = 'SET_OVERSIZED_FILES';
const SET_REJECTED_FILES = 'SET_REJECTED_FILES';

const ALLOWED_TYPES = new Set([
  'image/jpeg', 'image/png', 'image/gif', 'image/bmp',
  'image/webp', 'image/tiff', 'image/x-icon', 'image/vnd.microsoft.icon',
]);

function generateId() {
  return Math.random().toString(36).substring(2, 9) + Date.now().toString(36);
}

export default {
  namespaced: true,
  state: {
    files: [],
    oversizedFiles: [],
    rejectedFiles: [],
  },
  getters: {
    files: state => state.files,
    completedFiles: state => state.files.filter(f => f.status === 'completed'),
    oversizedFiles: state => state.oversizedFiles,
    rejectedFiles: state => state.rejectedFiles,
  },
  mutations: {
    [ADD_FILE](state, file) {
      state.files.push(file);
    },
    [UPDATE_FILE_PROGRESS](state, { id, progress }) {
      const file = state.files.find(f => f.id === id);
      if (file) file.progress = progress;
    },
    [COMPLETE_FILE](state, { id, base64 }) {
      const file = state.files.find(f => f.id === id);
      if (file) {
        file.base64 = base64;
        file.status = 'completed';
        file.progress = 100;
      }
    },
    [REMOVE_FILE](state, id) {
      state.files = state.files.filter(f => f.id !== id);
    },
    [CLEAR_FILES](state) {
      state.files = [];
      state.oversizedFiles = [];
      state.rejectedFiles = [];
    },
    [SET_OVERSIZED_FILES](state, names) {
      state.oversizedFiles = names;
    },
    [SET_REJECTED_FILES](state, names) {
      state.rejectedFiles = names;
    },
  },
  actions: {
    addFiles({ commit, state }, fileList) {
      const MAX = 10 * 1024 * 1024;
      const FILE_LIMIT = 10;
      const slots = FILE_LIMIT - state.files.length;
      const all = Array.from(fileList).slice(0, slots);

      const unsupported = all.filter(f => !ALLOWED_TYPES.has(f.type)).map(f => f.name);
      const typeSafe = all.filter(f => ALLOWED_TYPES.has(f.type));
      commit(SET_REJECTED_FILES, unsupported);

      const oversized = typeSafe.filter(f => f.size > MAX).map(f => f.name);
      const valid = typeSafe.filter(f => f.size <= MAX);
      commit(SET_OVERSIZED_FILES, oversized);

      if (!valid.length) return;

      valid.forEach((file) => {
        const id = generateId();
        const ext = file.name.split('.').pop().toUpperCase();
        commit(ADD_FILE, {
          id,
          name: file.name,
          size: file.size,
          ext,
          base64: null,
          status: 'uploading',
          progress: 0,
        });

        const reader = new FileReader();

        reader.onprogress = (event) => {
          if (event.lengthComputable) {
            commit(UPDATE_FILE_PROGRESS, {
              id,
              progress: Math.round((event.loaded / event.total) * 100),
            });
          }
        };

        reader.onloadend = (event) => {
          commit(COMPLETE_FILE, { id, base64: event.target.result });
        };

        reader.onerror = () => {
          commit(REMOVE_FILE, id);
        };

        reader.readAsDataURL(file);
      });
    },
    removeFile({ commit }, id) {
      commit(REMOVE_FILE, id);
    },
    clearFiles({ commit }) {
      commit(CLEAR_FILES);
    },
  },
};
